import * as React from "react";
import { FormattedMessage } from "react-intl";
import { useRef } from "react";

interface UserItem {
  name: React.ReactNode;
  icon: string;
  value: string;
  unit: string;
}

interface AppReportHeadProps {
  orgName: string;
  organizationLogo: string;
  user?: UserItem[];
}

const AppReportHead: React.FC<AppReportHeadProps> = ({ orgName, organizationLogo, user }) => {
  const orgNameRef = useRef<HTMLDivElement>(null);

  // 打印时调整字体大小的函数
  const adjustFontSizeForPrint = () => {
    if (orgNameRef.current) {
      const textLength = orgName.length;
      let calculatedFontSize = '2rem';
      
      // 根据字符长度调整字体大小
      if (textLength > 20) {
        calculatedFontSize = '1.2rem';
      } else if (textLength > 15) {
        calculatedFontSize = '1.4rem';
      } else if (textLength > 10) {
        calculatedFontSize = '1.6rem';
      } else if (textLength > 8) {
        calculatedFontSize = '1.8rem';
      }
      
      // 应用字体大小到元素
      orgNameRef.current.style.fontSize = calculatedFontSize;
    }
  };

  // 监听打印事件
  React.useEffect(() => {
    const handleBeforePrint = () => {
      adjustFontSizeForPrint();
    };

    const handleAfterPrint = () => {
      // 打印完成后恢复原始样式（如果需要）
      if (orgNameRef.current) {
        orgNameRef.current.style.fontSize = '';
      }
    };

    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, [orgName]);

  return (
    <>
        <div className="appReportHead">
          <div  className="header-top-title">
            <FormattedMessage id="postureReport" />
            <div className="header-top-title-span">
            <FormattedMessage id="patientId" />：{user ? user[6].value : ''}
            </div>
          </div>
          <div 
            className="header-top-name" 
            ref={orgNameRef}
          >
            {orgName}
          </div>
          {organizationLogo && organizationLogo.trim() !== '' && (
            <img src={organizationLogo} className="logo-xz" alt="logo" />
          )}
        </div>
        <div className="titleDivider"></div>
        
        {/* 个人信息 */}
        {user && user.length > 0 && (
          <div className="appReportPerson">
            {user.map((item, index) => {
              if (user.length - 1 != index) {
                return (
                    <div className="appReportPItem" key={index}>
                      <img className="pItemIcon" src={item.icon} alt="icon" />
                      <div className="pItemName">{item.name}</div>
                      <div className="pItemValue">{item.value}</div>
                      <div className="pItemValue">{item.unit}</div>
                    </div>
                );
              }
            })}
          </div>
        )}
    </>
  );
};

export default AppReportHead;